import { useTranslation } from 'next-i18next'

import styles from '~/shared/styles/HomLoader.module.css'

import SVGImage from './Image/SVGImage'

export default function HouseOfMathLoader({
  className,
  disableFade,
  subtitle,
  hideLogo,
}: {
  className?: string
  disableFade?: boolean
  hideLogo?: boolean
  subtitle?: string
}): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])
  const background = 'bg-gradient-to-r from-orange-logo via-pink-logo to-blue-logo bg-clip-text'
  const text = 'select-none text-11 leading-none text-transparent text-center'

  return (
    <section
      className={`w-full h-full flex flex-col items-center justify-center ${
        disableFade ? '' : styles['hom-loader-animate-fade']
      } ${className}`}
    >
      {!hideLogo && (
        <SVGImage
          alt={t('imageAlt:icons.houseOfMath')}
          height={45}
          imageClassName="w-64"
          srcKey="logos/house-of-math.svg"
          width={234}
        />
      )}
      <section className="w-64">
        <div className="relative w-full h-12">
          <div className={`absolute inset-0 ${styles['hom-loader']}  ${styles['hom-loader-animate-dot-1']} `}>
            <div className={`${background} ${text}`}>
              <span className="mr-12">&bull;</span>
            </div>
          </div>
          <div className={`absolute inset-0 ${styles['hom-loader']} ${styles['hom-loader-animate-dot-2']}`}>
            <div className={`${background} ${text}`}>
              <span>&bull;</span>
            </div>
          </div>
          <div className={`absolute inset-0 ${styles['hom-loader']} ${styles['hom-loader-animate-dot-3']}`}>
            <div className={`${background} ${text}`}>
              <span className="ml-12">&bull;</span>
            </div>
          </div>
        </div>
      </section>
      <div className="text-center">{subtitle && <p>{subtitle}</p>}</div>
    </section>
  )
}
